<template>
    <div>
      <div id="header-container" class="pl-5">
        <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
        <div class="pt-4 text-white">
          <h3 class="text-white">{{ $t('Edit Profile') }}</h3>
          <span class="fz-16 fw-400">{{ $t('Please fill in your profile information') }}</span>
        </div>
      </div>
      <b-container fluid class="pb-5 transaction-section">
        <div id="body-container">
          <b-row>
            <b-col cols="12" md="6">
              <h3 class="p-2">{{ $t('Profile Information') }}</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Full name as per Identity Card/Passport') }} <span class="text-danger">*</span></label>
                <input type="text" v-model="fullname" name="fullname" value="" :placeholder="$t('Full name as per Identity Card/Passport')" class="form-control" :disabled="isDisabled" @keydown="FullNameCondition" onpaste="return false;" autocomplete=off>
                <div v-if="error['fullname']" class="invalid-feedback d-block mb-3">
                  {{$t(error['fullname'])}}
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Identity Card / Passport Number') }} <span class="font-italic small">({{ $t('Please include all special characters') }})</span> <span class="text-danger">*</span></label>
                <input type="text" v-model="ic" name="ic" value="" :placeholder="$t('Identity Card / Passport Number')" class="form-control" @keydown="onChange('ic')" :disabled="isDisabled">
                <div v-if="error['ic']" class="invalid-feedback d-block mb-3">
                  {{$t(error['ic'])}}
                </div>
              </div>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col sm="12" md="6">
              <div class="d-block d-md-flex">
                <div class="form-group mb-0 p-2 w-100">
                  <label class="d-block d-md-none">{{ $t('Phone Code') }} <span class="text-danger">*</span></label>
                  <label class="d-none d-md-block">{{ $t('Phone Number') }} <span class="text-danger">*</span></label>
                  <Select2 v-model="phone_code" :options="phoneOpt" @select="onChange('phone_code')" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Phone Code"),disabled:isDisabled }' class="form-control" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                  <div v-if="error['phone_code']" class="invalid-feedback d-block mb-3">
                    {{$t(error['phone_code'])}}
                  </div>
                </div>
                <div class="form-group mb-0 p-2 w-100">
                  <label class="d-block d-md-none">{{ $t('Phone Number') }} <span class="text-danger">*</span></label>
                  <label class="d-none d-md-block">&nbsp;</label>
                  <input type="text" v-model="phone" name="phone" value="" :placeholder="$t('Phone Number')" class="form-control" @keydown="onChange('phone')" :disabled="isDisabled">
                  <div v-if="error['phone']" class="invalid-feedback d-block mb-3">
                    {{$t(error['phone'])}}
                  </div>
                </div>
  
              </div>
              
            </b-col>
  
  
            <b-col sm="12" md="3">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Date of birth') }} <span class="text-danger">*</span></label>
                <date-picker v-model="dob" :lang="lang_date" input-class="form-control" format="DD-MM-YYYY" value-type="YYYY-MM-DD" @change="onChange('dob')" :disabled="isDisabled"></date-picker>
                <div v-if="error['dob']" class="invalid-feedback d-block mb-3">
                  {{$t(error['dob'])}}
                </div>
              </div>
            </b-col>
  
            <b-col sm="12" md="3">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Gender') }} <span class="text-danger">*</span></label>
                <Select2 v-model="gender" :options='["Male","Female"]' @select="onChange('gender')" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Gender"),disabled:isDisabled }' class="form-control" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                <div v-if="error['gender']" class="invalid-feedback d-block mb-3">
                  {{$t(error['gender'])}}
                </div>
              </div>
            </b-col>
  
          </b-row>
  
          <b-row>
            <b-col sm="12" md="4">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Annual Income') }} <span class="text-danger">*</span></label>
                <select name="annual_income_range_id" v-model="annual_income_range_id" class="form-control" @change="onChange('annual_income_range_id')" :disabled="isDisabled">
                  <option value="">-- {{ $t('Select Annual Income') }} --</option>
                  <option v-for="item in annual_income_list" :value="item.id" :key="item.id">{{getAmount(item.start_salary)}} - {{getAmount(item.end_salary)}}</option>
                </select>
                <div v-if="error['annual_income_range_id']" class="invalid-feedback d-block mb-3">
                  {{$t(error['annual_income_range_id'])}}
                </div>
              </div>
            </b-col>
            <b-col sm="12" md="4">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Occupation') }} <span class="text-danger">*</span></label>
                <select name="Occupation" v-model="job_id" class="form-control" @change="onChange('job_id')" :disabled="isDisabled">
                  <option value="">-- {{ $t('Select Occupation') }} --</option>
                  <option v-for="item in job_list" :value="item.id" :key="item.id">{{item.name}}</option>
                </select>
                <div v-if="error['job_id']" class="invalid-feedback d-block mb-3">
                  {{$t(error['job_id'])}}
                </div>
              </div>
            </b-col>
            <b-col sm="12" md="4">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Position') }} <span class="text-danger">*</span></label>
                <input type="text" v-model="position" name="position" value="" :placeholder="$t('Position')" class="form-control" @keydown="onChange('position')" :disabled="isDisabled">
                <div v-if="error['position']" class="invalid-feedback d-block mb-3">
                  {{$t(error['position'])}}
                </div>
              </div>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col xl="6" sm="12">
              <div class="form-group mb-3 p-2">
                <label>{{ $t('Nationality') }} <span class="text-danger">*</span></label>
                <Select2 v-model="nationality" :options='nationalityOpt' @select="onChange('nationality')" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Nationality"),disabled:isDisabled }' class="form-control" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                <div v-if="error['nationality']" class="invalid-feedback d-block mb-3">
                  {{$t(error['nationality'])}}
                </div>
              </div>
            </b-col>
  
            <b-col xl="6" sm="12">
              <div class="form-group mb-0 p-2">
                <label>{{ $t('Country') }} <span class="text-danger">*</span></label>
                <Select2 v-model="country_code" :options="countryOpt" @select="onSelectCountry($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Country"),disabled:isDisabled}' class="form-control" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                <div v-if="error['country_code']" class="invalid-feedback d-block mb-3">
                  {{$t(error['country_code'])}}
                </div>
              </div>
            </b-col>
          </b-row>
  
          <b-row>
            
            <b-col xl="4" sm="12">
                <div class="form-group mb-0 p-2">
                <label>{{ $t('State') }} <span class="text-danger">*</span></label>
                <Select2 v-model="state_code" :options="stateOpt" @select="onSelectState($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("State"),disabled:isDisabled}' class="form-control" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                <div v-if="error['state_code']" class="invalid-feedback d-block mb-3">
                    {{$t(error['state_code'])}}
                </div>
                </div>
            </b-col>
  
            <b-col xl="4" sm="12">
                <div class="form-group mb-0 p-2">
                <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                <input type="text" v-model="city_name" name="city_name" value="" :placeholder="$t('City')" class="form-control" @keydown="onChange('city_name')" :disabled="isDisabled">
                <div v-if="error['city_name']" class="invalid-feedback d-block mb-3">
                    {{$t(error['city_name'])}}
                </div>
                </div>
            </b-col>

            <b-col xl="4" sm="12">
                <div class="form-group mb-0 p-2">
                <label>{{ $t('Postal Code') }} <span class="text-danger">*</span></label>
                <input type="text" v-model="postal_code" name="postal_code" value="" :placeholder="$t('Postal Code')" class="form-control" @keydown="onChange('postal_code')" :disabled="isDisabled">
                <div v-if="error['postal_code']" class="invalid-feedback d-block mb-3">
                    {{$t(error['postal_code'])}}
                </div>
                </div>
            </b-col>
  
          </b-row>
  
          <b-row>
            <b-col xl="12">
                <div class="form-group mb-4">
                    <label>{{ $t('Address') }} <span class="text-danger">*</span></label>
                    <textarea name="addresss" v-model="address" class="form-control" rows="4" @keydown="onChange('address')" :disabled="isDisabled"></textarea>
                    <div v-if="error['address']" class="invalid-feedback d-block mb-3">
                        {{$t(error['address'])}}
                    </div>
                </div>
            </b-col>
        </b-row>
  
          
          <button v-if="!isDisabled" type="button" @click="submitProfile" class="btn btn-primary d-block w-100 mb-3" >{{ $t('Submit') }}</button>
  
        </div>
        
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
    import Vue from 'vue'
    
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import Select2 from 'v-select2-component';
  
    import Global from '@/services/Global';
    import Common from '@/services/Common';
    import CreateAccount from '@/services/CreateAccount';
    
    import LoaderComponent from "@/components/LoaderComponent";
    
    import 'vue2-datepicker/locale/zh-cn';
    import 'vue2-datepicker/locale/zh-tw';
    import 'vue2-datepicker/locale/ja';
    import 'vue2-datepicker/locale/en';
  
  
    export default {
      name: 'edit-profile',
      data() {
        return {
          publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
          fullname:'',
          ic:'',
          gender:'',
          job_id:'',
          annual_income_range_id:'',
          address:'',
          phone_code:'',
          phone:'',
          dob:null,
          account_type:'1',
          position:'',
          country_code:'',
          state_code:'',
          city_name:'',
          postal_code:'',
          nationality:'',
          phoneOpt:[],
          countryOpt:[],
          stateOpt:[],
          nationalityOpt:[],
          job_list:[],
          annual_income_list:[],
          isDisabled:false,
          isLoading:false,
          lang_date:'en',
          kyc_data:{
            poi:[
                {
                "id":1,
                "name":"Identity Card",
                "list":[
                    {"type":2},
                    {"type":3},
                    {'type':4}
                ]
                },
                {
                "id":2,
                "name":"Passport",
                "list":[
                    {'type':5},
                    {'type':6}
                ]
                }
            ]
        },
          error:{
            account_type:'',
            fullname:'',
            ic:'',
            gender:'',
            phone:'',
            phone_code:'',
            country_code:'',
            state_code:'',
            city_name:'',
            postal_code:'',
            nationality:'',
            dob:'',
            annual_income_range_id:'',
            job_id:'',
            position:'',
            address:''
          }
        }
      },
      components: { DatePicker,LoaderComponent,Select2 },
      methods:{
        onSelectCountry({id,text}){
            var self = this;
            this.onChange('country_code');
            self.stateOpt = [];
            if(text){
            this.state_code="";
            this.city_name="";
            }
            
            Common.states({"country_code":id}).then(response => {
            if(response.status == 200 && response.data.success){
                    const state = response.data.data;
                    for (let i = 0; i < state.length; i++) {
                    self.stateOpt.push({"id":state[i]['id'],"text":state[i]['name']});
                    }
                }
            });
        },
        onSelectState({id,text}){
            var self = this;
            this.onChange('state_code');
            if(text){
            this.city_name="";
            }
        },
        doEscapeMarkup(markup){
          return markup;
        },
        FullNameCondition(evt) {
          this.onChange('fullname');
          var inputValue = evt.key;
          var isAlphabetic = /^[a-zA-Z]$/.test(inputValue);
          var isBackspace = evt.key === 'Backspace';
          var isSpace = evt.key === ' ';
  
          if (!isAlphabetic && !isBackspace && !isSpace) {
            evt.preventDefault();
          }
        },
        getAmount(amount){
          return "USD "+Global.addCommas(amount);
        },
        onChange(name){
          this.error[name]="";
        },
        getMessage: function (key) {
          return this.$t(key)
        },
        checkKyc(current){
        Common.getKyc().then(response => {
          const data = response.data.data;
          let approve = true;
          
          Object.keys(this.kyc_data).forEach((key) => {
            const doc_list = this.kyc_data[key][current[key]].list;
            for (let i = 0; i < doc_list.length; i++) {
              if(data.kyc[doc_list[i].type].status!=1){
                approve=false;
              }
            }
          });

            if(approve){
              this.isDisabled = true;
            }
          
        }).catch(err => {
          this.checkError(err);
        });
      },
        submitProfile(){
          this.isLoading = true;
          const data = {
            fullname:this.fullname,
            job_id:this.job_id,
            annual_income_range_id:this.annual_income_range_id,
            position:this.position,
            phone_code:this.phone_code,
            phone:this.phone,
            ic:this.ic,
            dob:this.dob,
            country_code:this.country_code,
            state_code:this.state_code,
            city_name:this.city_name,
            postal_code:this.postal_code,
            nationality:this.nationality,
            address:this.address,
            gender:this.gender
          };
  
          Common.update_profile(data).then(response => {
            if(response.status == 200 && response.data.success){
              this.isLoading = false;
              this.$swal({
                icon: 'success',
                title: this.getMessage('Success'),
                showConfirmButton: true,
              }).then((result) => {
                window.location.reload(); 
              });
            }
          }).catch(err => {
            this.isLoading = false;
            this.checkError(err);
          });
        },
        checkError(err){
          try{
            const response = err.response;  
            if(response.status == 400){
                Object.keys(response.data.data).forEach((key) => {
                  this.error[key] = response.data.data[key][0];
                });
              }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                      path: '/login', 
                    });
                  }
            else{
              if(localStorage.getItem("token")){
                var msg = (response.data)?response.data.message:err.message;
                this.$notify({
                type: 'warn',
                text: msg
                })
              }
            }
          }catch(e){
            console.log(err);
          }
        }
      },
      mounted(){
        var self = this;
  
        const tmp = localStorage.getItem("lang-key").toLocaleLowerCase();
        let arr = tmp.split("-");
  
        this.lang_date = (arr[0]==arr[1])?arr[0]:tmp;
        
        Common.countries().then(response => {
          if(response.status == 200 && response.data.success){
            const countries=response.data.data;
  
            for (let i = 0; i < countries.length; i++) {
              const phone_code = "<span class='text-caption'>("+countries[i]['phonecode']+")</span>";
              const flag = '<span class="fi fi-'+countries[i]['iso2'].toLowerCase()+'"></span>';  
              const country_name = "<span>"+this.$t(countries[i]['name'])+"\t\t\t"+"</span>";
              const nationality_name = "<span>"+countries[i]['nationality']+"\t\t\t"+"</span>";
  
              self.phoneOpt.push({"id":countries[i]['iso2'],"text":flag+country_name+phone_code});
              self.nationalityOpt.push({"id":countries[i]['iso2'],"text":flag+nationality_name});
              self.countryOpt.push({"id":countries[i]['iso2'],"text":flag+country_name});
            }
          }
        });
  
        Common.job().then(response => {
          if(response.status == 200 && response.data.success){
            this.job_list=response.data.data;
          }
        });
  
        Common.annual_income().then(response => {
          if(response.status == 200 && response.data.success){
            this.annual_income_list=response.data.data;
          }
        });
  
        Common.profile().then(response => {
          if(response.status == 200 && response.data.success){
  
            const profile = response.data.data;
            this.fullname = profile.fullname;
            this.ic=profile.ic;
            this.job_id = (profile.job_id)?profile.job_id:'';
            this.position=profile.position;
            this.annual_income_range_id=(profile.annual_income_range_id)?profile.annual_income_range_id:'';
            this.phone = (profile.phone!=0)?profile.phone:'';
            
            this.dob = (!profile.dob || profile.dob=="0000-00-00")?"":profile.dob;
            this.address = profile.address;
            this.phone_code = profile.phone_code;
            this.country_code = profile.country_code;
            this.postal_code = profile.postal_code;
            this.city_name = profile.city_name;
            this.nationality = profile.nationality;
            this.state_code = profile.state_code;
            this.gender = profile.gender;
            
            if(this.country_code){
              this.onSelectCountry({"id":this.country_code});
            }
            if(this.state_code){
                this.onSelectState({"id":this.state_code});
            }
  
            if(profile.doc_type!=null && profile.doc_type>0){
              this.checkKyc({"poi":parseInt(profile.doc_type)-1});
            }
          }
        }).catch(err => {
          this.checkError(err);
        });
      }
    };
  </script>
  